export default __webpack_public_path__ + "static/media/gallery_05.c0b052d7.jpg";